<template>
<div class="avatar-main-container">
    <input class="hidden-input" type="file" :disabled="!changable" ref="inputFile" accept=".png, .jpg, .jpeg" @change="uploadImage">
    <div class="avatar-container" @click="changeImage" v-if="!aspectRatio">
        <div class="avatar" ref="test" :class="{'img-ok': isLoaded, changable: changable}" :style="`width: ${size}px; height: ${size}px;`">
            <img :src="url" v-show="loaded && !isError" :width="`${size}px`" :height="`${size}px`" @load="loaded" @error="loadError">
        </div>
    </div>
    <div class="avatar-container" @click="changeImage" v-if="aspectRatio">
        <div class="avatar adImg" ref="test" :class="{'img-ok': isLoaded}" :style="`width: ${size * aspectRatio * 16 / 9}px; height: ${size}px;`">
            <img :src="url" v-show="loaded && !isError" :width="`${width}px`" :height="`${size}px`" @load="loaded" @error="loadError">
        </div>
    </div>
    <el-dialog :lock-scroll="true" append-to-body width="840px" :close-on-click-modal="false" v-if="clipVisible" :visible="true" :before-close="closeClipBox">
        <div slot="title">
            <span class="title">上传图片</span>
            <span class="sub-title" v-if="aspectRatio">（尺寸不小于320px*180px，大小不超过2M，格式为jpg、png、jpeg）</span>
            <span class="sub-title" v-else>（尺寸不小于180px*180px，大小不超过2M，格式为jpg、png、jpeg）</span>
        </div>
        <clip :imageDataUrl="imageDataUrl" @choose-another-image="changeImage" @postFile="postImage" v-if="!aspectRatio"></clip>
        <clip-new :imageDataUrl="imageDataUrl" @choose-another-image="changeImage" @postFile="postImage" :shearRatio="true" v-if="aspectRatio"></clip-new>
    </el-dialog>
    <image-error-dialog :visible.sync="imageErrorDialogVisible" :error-info="errorText" @select="changeImage" :aspectRatio="aspectRatio"></image-error-dialog>
</div>
</template>
<script>
import Clip from './Clip.vue';
import ClipNew from './ClipNew.vue';
import ImageErrorDialog from './ImageErrorDialog.vue';
import dao from '@/lib/dao.js';
import bus from '@/lib/bus.js';
export default {
    components: {
        Clip,
        ImageErrorDialog,
        ClipNew
    },
    props: {
        url: {
            type: String,
            default: ''
        },
        changable: {
            type: Boolean,
            default: false
        },
        size: {
            type: Number,
            default: 64
        },
        aspectRatio: {
            type: Number,
            default: 0
        }
    },
    computed: {
        width() {
            return Math.round(this.size * 16 / 9)
        }
    },
    data() {
        return {
            isLoaded: false,
            isError: false,
            clipVisible: false,
            imageDataUrl: '',
            imgFile: {},
            imgWidth: 0,
            imgHeight: 0,
            imageErrorDialogVisible: false,
            errorText: '',
            isError: false
        }
    },
    methods: {
        loaded() {
            this.isLoaded = true;
            this.isError = false;
        },
        loadError() {
            this.isError = true;
            this.isLoaded = false;
        },
        changeImage() {
            if (this.changable) {
                this.$refs.inputFile.click();
            }
        },
        changeAdImage() {
            console.log('99909')
            this.$refs.inputFile.click();
        },
        uploadImage(e) {
            let imgFile = e.target.files[0];
            let reader = new FileReader();
            this.beforeUpload(imgFile).then(needClip => {
                this.imgFile = imgFile;
                if (needClip) {
                    this.clipVisible = true;
                } else {
                    this.postImage({
                        x: 0,
                        y: 0,
                        xCutSize: this.imgWidth,
                        yCutSize: this.imgHeight
                    });
                }
            }).catch(message => {
                this.imageErrorDialogVisible = true;
                this.errorText = message;
            });
        },
        beforeUpload(file) {
            let promise = new Promise((resolve, reject) => {
                let reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = (e) => {
                    let data = e.target.result;
                    let image = new Image();
                    image.onload = () => {
                        let width = image.width;
                        let height = image.height;
                        this.imgWidth = width;
                        this.imgHeight = height;
                        this.$refs.inputFile.value = '';
                        if(this.aspectRatio) {
                            if (width < 320 || height < 180) {
                                reject('图片尺寸有误！应不小于320px * 180px');
                            } else if(file.size > 2 * 1024 * 1024) {
                                reject('图片过大！大小应不超过2M');
                            } else if(file.type.indexOf('jpeg') < 0 && file.type.indexOf('png') < 0) {
                                reject('图片格式有误！格式应为jpg、png、jpeg');
                            } else {
                                this.imageDataUrl = data;
                                if (width === 320 && height === 180) {
                                    resolve(false);
                                } else {
                                    resolve(true);
                                }
                            }
                        } else {
                            if (width < 180 || height < 180) {
                                reject('图片尺寸有误！应不小于180px * 180px');
                            } else if(file.size > 2 * 1024 * 1024) {
                                reject('图片过大！大小应不超过2M');
                            } else if(file.type.indexOf('jpeg') < 0 && file.type.indexOf('png') < 0) {
                                reject('图片格式有误！格式应为jpg、png、jpeg');
                            } else {
                                this.imageDataUrl = data;
                                if (width === 180 && height === 180) {
                                    resolve(false);
                                } else {
                                    resolve(true);
                                }
                            }
                        }
                    };
                    image.onerror = () => {
                        this.$refs.inputFile.value = '';
                        reject('图片有误！请重新上传');
                    };
                    image.src = data;
                };
            });
            return promise;
        },
        postImage(param) {
            param.logo = this.imgFile;
            dao[bus.type].postFile(param).then(data => {
                this.clipVisible = false;
                // data = data.replace(/http(s)?:/, '');
                this.$emit('image-ok', data);
            }).catch(msg => {
                this.$message.error(msg);
            });
        },
        closeClipBox() {
            this.clipVisible = false;
        }
    },
    mounted() {
        console.log('aspectRatio', this.aspectRatio)
    }
}
</script>
<style lang="less" scoped>
.avatar-main-container {
    position: relative;
    display: inline-block;
    font-size: 0;
    line-height: 0;
}
.hidden-input {
    position: absolute;
    width: 1px;
    height: 1px;
    left: 5px;
    top: 5px;
    opacity: 0;
}
.avatar-container {
    display: inline-block;
    position: relative;
}
.avatar {
    border-radius: 32px;
    overflow: hidden;
    background: url(./../assets/default_avatar.png) center center no-repeat;
    background-size: 100% 100%;
    display: inline-block;
    img[src=""],img:not([src]){
        opacity: 0;
    }
    &.adImg {
        border-radius: 7px;
        margin-right: 90px;
    }

    &.changable:hover:after {
        position: absolute;
        content: '更换';
        background: rgba(0, 0, 0, 0.6);
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        cursor: pointer;
        text-align: center;
        font-size: 12px;
        border-radius: 50px;
        color: #fff;
        box-sizing: border-box;
        padding-top: 50%;
    }

    &.img-ok {
        background: #fff;
    }
}
.title {
    font-size: 18px;
    color: #5C667E;
}
.sub-title {
    font-size: 12px;
    color: #5C667E;
}
</style>



// WEBPACK FOOTER //
// src/components/Avatar.vue